import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import logo from '../../assets/logo.jpeg';

import './styles/logo.css';

const Logo = (props) => {
  const { width, link } = props;

  const imageElement = (
    <img src={logo} alt="logo" className="logo" width={width} />
  );

  return (
    <>
      {link ? <Link to="/">{imageElement}</Link> : imageElement}
    </>
  );
};

Logo.propTypes = {
  width: PropTypes.number.isRequired,
  link: PropTypes.bool,
};

Logo.defaultProps = {
  link: true,
};

export default Logo;
